<div class="dropdown-wrapper">
  <form class="custom-input-container" autocomplete="off">
    <div [class]="'input-code fi fi-'+selectedCode"></div>
    <input
      type="text"
      class="control-input country-select-drop {{showDropdown?'highlight':''}}"
      [formControl]="countrySelect"
      [value]="selectedCountry"
      placeholder="Select a country"
      [ngClass]="{ 'padding-left': selectedCountry }"
      #countryFilter
      (input)="filterCountries($event.target.value)"
      (click)="showDropdown = !showDropdown"
      >
      <div class="dropdown-arrow" (click)="showDropdown = !showDropdown"></div>
      @if (countryFilter.value.length > 0) {
        <button style="background-color: transparent" class="search-button" (click)="isSearch()">
          <img src="../../../../../../assets/svg/search-close.svg">
        </button>
      }
      <div class="dropdown-content" [ngClass]="{'show-dropdown-content': showDropdown === true}">
        <ul>
          @for (country of filteredCountries; track country) {
            <li
              (click)="selectCountry(country)"
              class="dropdown-list"
              [ngClass]="{'selected': country.name === selectedCountry}">
              <span [class]="'fx fi fi-'+country.code.toLowerCase()"></span>
              {{country.name}}
            </li>
          }
          @if (filteredCountries.length === 0) {
            <li class="noResults" disabled>
              No results found.
            </li>
          }
        </ul>
      </div>
    </form>

  </div>
  @if (countrySelect.touched && countrySelect.errors) {
    <div class="validationField">
      <span class="fa fa-exclamation-circle"></span>
      Country is required
    </div>
  }
